<template>
    <div :class="'search ' + $store.getters['homeSearchState']" >
      <div class="search__content">
        <div class="search__suggestions suggestions" v-if="results">
          <div class="suggestions__content content" >
            <router-link v-if="suggestion.product_id && loading == 0" :to="{name: 'ProductDetail', params: {id: suggestion.product_id}}" class="suggestion" v-for="suggestion in results" :key="suggestion.product_id">
              <div class="suggestion__ref">
                {{ suggestion.product_code }}
              </div>
              <div class="suggestion__name" >
                <span v-html="$options.filters.bold(suggestion.product_label, searched)"></span>
                <br/>
                <small>{{ suggestion.family_name }}</small>
              </div>
            </router-link>
            <div class="suggestions__loader" v-if="loading == 1">
              <i></i>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: "SearchResultsHome",
  props: [
    "loading",
    "searched",
    "mobile"
  ],
  data() {
    return {
    }
  },
  filters: {
    bold: function (res, searched) {
      if (!res) return ''
      return res.replace(searched, '<strong>' + searched + '</strong>');
    }
  },
  computed: {
    // Récupération des résultats stockés côté Vue (après requête AJAX les résultats sont stockés, on les récupère ici)
    results: function() {
      let results = this.$store.getters['search/getResults'];
      return results;
    }
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grisfonce;
    border-radius: 20px;
    height: 5px;
  }

  .search{ position: absolute; height: auto; max-height: 300px; top: -100vh; width: 100%; background-color: white; z-index: 11; transition: top 300ms ease-in-out; display: flex; flex-direction: column;
    &.active{ top: 65px; }
    &__header{ height: auto; padding: 100px 30px 30px 30px;
      input{ background-color: transparent; border: none; width: 100%; color: $color3; border: none; height: 35px; font-size: 25px; outline: none; font-family: 'ClanPro'; }
      input:-internal-autofill-selected{ display: none; background-color: transparent !important;  }
      a{ position: absolute; top: 10px; right: 30px;
        img{ width: 30px; }
      }
    }
    &__content{ background-color: white; flex: 1; padding: 20px 30px 20px;  overflow: auto; min-height: 100px;
      .suggestions{ display: flex; position: relative;
        &__title{ color: $color3; font-size: 16px; font-family: 'ClanProBold'; width: 130px;

        }
        &__content{ display: flex; flex-wrap: wrap;
          .suggestion{ display: flex; font-size: 12px; font-family: 'ClanPro'; margin-bottom: 10px; width: calc(100% / 2);
            &__ref{ color: $grisfonce; font-size: 10px; width: 65px; }
            &__name{ font-family: 'ClanPro';  color: $grisfonce; font-size: 12px; margin-left: 20px; flex: 1;
              span{
                strong{ font-family: 'ClanProBold'; }
              }
              small{ font-family: 'ClanPro'; font-size: 10px; }
            }
            &:hover{ text-decoration: none; }
          }
        }
        &__loader { background-color: $color1; height: 50px; width: 50px; border-radius: 50%; text-align: center; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
            i { display: block; margin: 0 auto;
              &:before { content: "."; animation-name: load; animation-duration: 800ms; animation-iteration-count: infinite; width: auto; color: white; display: inline-block; font-size: 23px;
              }
            }
          }
      }
    }
    &.mobile{ top: 167px; position: absolute;
      .search__suggestions{
        .suggestions__content{
          .suggestion{ width: 100%;
            &__ref{  }
            &__name{ flex: 1; text-align: left;  }
          }
        }
      }
    }
  }


  @keyframes load {
    0% {
      content: ".";
    }
    33% {
      content: "..";
    }
    66% {
      content: "...";
    }
    100% {
      content: ".";
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Global/SearchResultsHome.vue